class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    //Re-render the facefilter forms so that it has the right number of available products when availability=1
    const sections = FacetFiltersForm.getSections();
    sections.forEach((section) => {
      const searchParams = new URLSearchParams(window.location.search);
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}&filter.v.availability=1`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderFilterFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderFilterFromFetch(url, event);
    });
  }

  connectedCallback() {
    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    // update .has-active-selections (used to prevent auto-close when drawer is closed)
    const filterAccordions = document.querySelectorAll('[id^="Details-filter"]');
    for (const accordion of filterAccordions) {
      const active = !!accordion.querySelector('.mobile-facets__checkbox:checked');
      accordion.classList.toggle('has-active-selections', active);
    }

    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderFilterFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
      });
  }

  static renderFilterFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document.dispatchEvent(
      new CustomEvent('facets-grid-update', { bubbles: true })
    );  

    // document
    //   .getElementById('ProductGridContainer')
    //   .querySelectorAll('.scroll-trigger')
    //   .forEach((element) => {
    //     element.classList.add('scroll-trigger--cancel');
    //   });

      window.scrollTo(0, 0); // fixes temp browser repaint glitch (grid pops over filters)
  }

  static updateLiveRegionFromCount(countHTML) {
    const liveRegion = document.getElementById('FilterActivityStatus');
    if (!liveRegion || !countHTML) return;

    // Strip HTML to plain text so screen readers get a clean message
    const tempDoc = new DOMParser().parseFromString(`<div>${countHTML}</div>`, 'text/html');
    const text = tempDoc.body.textContent.trim();

    if (text && liveRegion.textContent !== text) {
      liveRegion.textContent = text;
    }
  }

  static renderProductCount(html) {

    const parsedDoc = new DOMParser().parseFromString(html, 'text/html');
    const count = parsedDoc.getElementById('ProductCount')?.innerHTML;

    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');

    if (container && typeof count !== 'undefined') {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerDesktop && typeof count !== 'undefined') {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }

    // NEW: update aria-live status message when filters / results change
    FacetFiltersForm.updateLiveRegionFromCount(count);
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter, #FacetFiltersFormOpenDesktop .js-filter-open'
    );
    const appliedFiltersDiv = parsedHTML.querySelectorAll(
      '#FacetFiltersFormMobile .applied_filters_indicators'
    );

    const mobileFacetsOpenHeader = parsedHTML.querySelector("#FacetFiltersFormMobile .mobile-facets__inner .drawer__close--label");

    const facetVsPillDetailsElements = parsedHTML.querySelectorAll(
      '.vstylist__pill-ul'
    );
    const vsFacetBubbleElements = parsedHTML.querySelectorAll(
      '.facets.facets-pill div pop-menu'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter, .js-filter-open') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const idx = element.dataset.index;
      let target;
      if (element.classList && element.classList.contains('js-filter-open')) {
        target = document.querySelector(`#FacetFiltersFormOpenDesktop .js-filter-open[data-index="${idx}"]`);
      } else {
        target =
          document.querySelector(`#FacetFiltersFormMobile .js-filter[data-index="${idx}"]`) ||
          document.querySelector(`#FacetFiltersForm .js-filter[data-index="${idx}"]`) ||
          document.querySelector(`#FacetFiltersPillsForm .js-filter[data-index="${idx}"]`);
      }
      if (target) target.innerHTML = element.innerHTML;
    });

    const appliedEl = document.querySelector('#FacetFiltersFormMobile .applied_filters_indicators');
    if (appliedEl && appliedFiltersDiv[0]) appliedEl.innerHTML = appliedFiltersDiv[0].innerHTML;

    const drawerLabel = document.querySelector('#FacetFiltersFormMobile .mobile-facets__inner .drawer__close--label');
    if (drawerLabel && mobileFacetsOpenHeader) drawerLabel.innerHTML = mobileFacetsOpenHeader.innerHTML;

    facetVsPillDetailsElements.forEach((element) => {
      document.getElementById(`${element.id}`).innerHTML = element.innerHTML;
    });
    
      // let vsFacetBubble = document.querySelector('.facets.facets-pill.small-hide div pop-menu div .disclosure__button span span');
      let vsFacetBubbles = document.querySelectorAll('.facets.facets-pill div pop-menu');
      
      for(let i = 0; i < vsFacetBubbles.length; i++) {
        let vsFacetBubble = vsFacetBubbles[i];//.querySelector('div .disclosure__button span span');
        if (vsFacetBubble != null) {
          const vsFetchedFacetBubble = Array.from(vsFacetBubbleElements).find((value, index, array) => {
            return value.id === vsFacetBubble.id;
          }) 
          if(vsFetchedFacetBubble != null) {
            vsFacetBubble.querySelector('div .disclosure__button span span').innerHTML = vsFetchedFacetBubble.querySelector('div .disclosure__button span span').innerHTML;
          }
          else {
            vsFacetBubble.querySelector('div .disclosure__button span span').innerHTML = '<span class="mask-text__mask"><span>No Selection</span><span>No Selection</span></span>';
          }
        }
      }      
    

    // FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender && event) {
      const countTarget = event.target.closest('.js-filter, .js-filter-open');
      if (countTarget) FacetFiltersForm.renderCounts(countsToRender, countTarget);
    }

    if (typeof window.syncOpenDesktopFacetInputs === 'function') {
      window.syncOpenDesktopFacetInputs();
    }
    document.querySelectorAll('[data-open-filters-desktop]').forEach((root) => {
      root.querySelectorAll('[data-open-facet-search]').forEach((input) => {
        const panel = input.closest('.facets-open-inline__panel-inner');
        const list = panel && panel.querySelector('[data-open-facet-list]');
        if (list) {
          list.querySelectorAll('[data-open-facet-item]').forEach((li) => {
            li.hidden = false;
          });
        }
        input.value = '';
      });
    });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    console.log('onSubmitForm', searchParams);
  
    // --- Strip default price range (min: 0, max: 1999) so it's not applied ---
    if (searchParams) {
      const params = new URLSearchParams(searchParams);
  
      // adjust these keys if your input "name" attributes are different
      const minPrice = params.get('filter.v.price.gte');
      const maxPrice = params.get('filter.v.price.lte');
  
      // If both are at their default values, remove them from the query
      if (minPrice === '0' && maxPrice === '1999') {
        params.delete('filter.v.price.gte');
        params.delete('filter.v.price.lte');
      }
  
      searchParams = params.toString();
    }
    // ------------------------------------------------------------------------
  
    if (searchParams === 'filter.v.availability=1') {
      searchParams = searchParams.replace('filter.v.availability=1', '');
    }
  
    // on Virtual Stylist, when filters are cleared, refresh page to restart quiz
    if (document.getElementById('virtual-stylist-results') && !searchParams) {
      return window.location.href = window.location.pathname;
    }
  
    FacetFiltersForm.renderPage(searchParams, event);
  }  

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const forms = [];
    sortFilterForms.forEach((form) => {
        forms.push(this.createSearchParams(form));
    });
    this.onSubmitForm(forms.join('&'), event);

    // NOT TOO SURE WHY DAWN DEFAULT DOES MOBILE CHECKS
    // if (event.srcElement.className == 'mobile-facets__checkbox') {
    //   const searchParams = this.createSearchParams(event.target.closest('form'));
    //   this.onSubmitForm(searchParams, event);
    // } else {
    //   const forms = [];
    //   const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

    //   sortFilterForms.forEach((form) => {
    //     if (!isMobile) {
    //       if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
    //         const noJsElements = document.querySelectorAll('.no-js-list');
    //         noJsElements.forEach((el) => el.remove());
    //         forms.push(this.createSearchParams(form));
    //       }
    //     } else if (form.id === 'FacetFiltersFormMobile') {
    //       forms.push(this.createSearchParams(form));
    //     }
    //   });
    //   this.onSubmitForm(forms.join('&'), event);
    // }
  }

  onActiveFilterClick(event) {
    // on Virtual Stylist, when filters are cleared, refresh page to restart quiz
    if (document.getElementById('virtual-stylist-results')) {
      return window.location.href = event.currentTarget.href;
    }

    const url = event.currentTarget.href.indexOf('?') == -1
      ? ''
      : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);

    console.log('onActiveFilterClick', url);

    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
